import BasePage from "../../components/basePage";
import ContentCreate from "../../components/create/contentCreate";

import HeaderCreate from "../../components/create/headerCreate";
import { useCreate } from "./useCreate";

export default function CreateTickets() {

    const { type, setType, handleFile, tableHeaders, tableRows, handleFileRemoved, result, setResult, loading, setLoading } = useCreate()

    return (
        <BasePage>
            <HeaderCreate
                type={type}
                setType={setType}
                onFileLoaded={handleFile}
                onFileRemoved={handleFileRemoved}
                setResult={setResult}
                result={result}
                loading={loading}
                setLoading={setLoading}
            />
            <ContentCreate
                type={type}
                headers={tableHeaders}
                rows={tableRows}
                result={result}
                setResult={setResult}
                loading={loading}
                setLoading={setLoading}
            />
        </BasePage>

    )
}